<template>
  <div class="input-boxplot-customize">
    <!-- <br> -->
    <!-- <div>
      <input type="checkbox" id="discovery" value="discovery" v-model="cohortSelected" />
      <label>&nbsp;Discovery cohort</label>
      <br>
      <input type="checkbox" id="validation" value="validation" v-model="cohortSelected" />
      <label>&nbsp;Validation cohort</label>
    </div>
   <p>Checked: {{ cohortSelected }}</p> -->
    
    <div>
      <v-select
        :items="dataTypes"
        item-value="dataType"
        item-text="text"
        label="Data type:"
        v-model="boxplotDataType"
      >
      </v-select>
    </div>

    <div class="stratify-by">
      <v-switch
        v-model="stratify"
        :label="`Stratify by clinical variable`"
      ></v-switch>
      <div class="stratify-by-selector" v-if="stratify">
          <v-autocomplete
            :items="stratifyByOptions"
            label="Clinical feature to stratify by:"
            v-model="stratifyBy"
          ></v-autocomplete>
      </div>
    </div>

    <div>
      <v-switch
        v-model="useZScore"
        label="Use z-scores"
        color="red darken-3"
        hide-details
      ></v-switch>
    </div>
    <div>
      <v-switch
        v-if="twoCohorts()"
        v-model="combinedCohort"
        label="Show the two cohorts together"
        color="red darken-3"
        hide-details
      ></v-switch>
    </div>
  </div>
</template>

<script>
import stratifyVar from '../../refs/stratifyVar'
export default {
    
    name: "input-boxplot-customize",
    props: ['studySelected'],

    computed: {
      boxplotDataType: {
        get() { return this.$store.state.Boxplot_dataType },
        set(Boxplot_dataType) { this.$store.dispatch(
          'setBoxplotDataType', 
          { Boxplot_dataType }
        )}
      },
      categoryTracks() { 
        console.log('inputboxplotcustomize categoryTracks study selected', this.studySelected)
        return this.$store.state.Boxplot_categoryTracks[this.studySelected] },
      stratify: {
        get() {return this.$store.state.Boxplot_stratify},
        set(Boxplot_stratify) {
          this.$store.dispatch('setViewAttr', {view: 'Boxplot', 
                                              attrKey: 'stratify',
                                              attrVal: Boxplot_stratify
                                            })
        }
      },
      stratifyBy: {
        get() { return this.$store.state.Boxplot_stratifyBy },
        set(Boxplot_stratifyBy) { 
          if (this.stratify) {
            console.log('inputboxplotcustomize stratifyBy before', this.$store.state.Boxplot_stratifyBy)
            this.$store.dispatch('setBoxplotStratifyBy', { Boxplot_stratifyBy })
            console.log('inputboxplotcustomize stratifyBy after', this.$store.state.Boxplot_stratifyBy)

          } else {
            // console.log('inputboxplotcustomize stratifyBy before', this.$store.state.Boxplot_stratifyBy)
            this.$store.dispatch('setBoxplotStratifyBy', { Boxplot_stratifyBy: null })
            // console.log('inputboxplotcustomize stratifyBy after', this.$store.state.Boxplot_stratifyBy)
          }
          
        }
      },
      stratifyByOptions() {        
        console.log('inputboxplotcustomize stratifyByOptions', this.categoryTracks)
        // return Object.values(this.categoryTracks).flat().filter(track => (!this.categoryTracks.Numerical.includes(track) && track !== 'response'))
        // return Object.values(this.categoryTracks).flat().filter(track => (track !== stratifyVar[this.studySelected]['VarName']))
        // return 
        // return Object.values(this.categoryTracks).flat()
        return [stratifyVar[this.studySelected]['VarName'], ...Object.values(this.categoryTracks)]

      },
      useZScore: {
        get() { return this.$store.state.Boxplot_useZScore },
        set(v) { 
          this.$store.dispatch(
            'setUseZScore',
            { 
              view: 'Boxplot',
              useZScore: v 
            }
          )}
      },
      combinedCohort: {
        get() { return this.$store.state.Boxplot_combinedCohort },
        set(v) { 
          this.$store.dispatch(
            'setViewAttr',
            { 
              view: 'Boxplot',
              attrKey: 'combinedCohort',
              attrVal: v
            }
          )}
      },
      // cohortSelected: {
      //   get() { return this.$store.state.Boxplot_cohortSelected },
      //   set(v) { 
      //     // console.log
      //     this.$store.dispatch(
      //       'setViewAttr', { 
      //         view: 'Boxplot',
      //         attrKey: 'cohortSelected',
      //         attrVal: v 
      //       }
      //     )}
      // },
    },
    
    // data: () => ({
    //   // dataTypes: ['All', 'proteo', 'rna', 'phospho', 'glyco_glyco', 'phospho_glyco'],
    //   dataTypes: ['All', 'Proteo', 'RNA', 'CNV', 'Cell type'],
    //   stratify: false,
    //   // cohortSelected: [],
    //   cohortSelected: ['discovery', 'validation'],
    //   // discoveryCohort: false,
    // }),
    data() {
      return {
        // dataTypes: ['All', 'proteo', 'rna', 'phospho', 'glyco_glyco', 'phospho_glyco'],
        dataTypes: ['All', 'Proteo', 'RNA', 'CNV', 'CellType', 
          'Kinase', 'TranscriptionFactor', 'ubiq', 'glyco', 'phospho'],
        // stratify: false,
        checked: false,
        // cohortSelected: [],
        // cohortSelected: ['discovery', 'validation'],
        // discoveryCohort: false,
      }
    },
    watch: {
      
    },

    methods: {
        twoCohorts() {
            return this.studySelected === 'PTRC'
        },
    },
}
</script>

<style>
.input-boxplot-customize {
    margin: 10px;
}

/* .custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
} */
</style>